module.exports = __webpack_public_path__ + "static/6-f16af3449edb446298c2b261c4ff176e.png";